module.exports = __webpack_public_path__ + "static/media/stand.eb56a4d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/icon/stand.svg
// module id = 91
// module chunks = 0